/* Youghazi image popup. Scoped, one load guard, no dependencies.
 * - Shows after the configured delay, once the image has loaded.
 * - Frequency: every page load / session / day / week (storage in try/catch).
 * - Theme editor: always shows on load/select and ignores storage.
 * - Live preview override: add ?yh_popup=1 to any URL.
 * - Always closable: X button, backdrop click, Escape. Scroll lock is restored on close/pagehide.
 * - Never shown if the image fails to load. */
(function () {
  'use strict';

  if (window.__yhpLoaded) { if (window.__yhpInitAll) window.__yhpInitAll(); return; }
  window.__yhpLoaded = true;

  var STORAGE_PREFIX = 'yhp:';
  var DAY = 24 * 60 * 60 * 1000;
  var openInstance = null;

  function designMode() { return !!(window.Shopify && window.Shopify.designMode === true); }
  function forced() {
    try { return /(?:\?|&)yh_popup=1(?:&|$)/.test(window.location.search); } catch (e) { return false; }
  }
  function reduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ---------- frequency ---------- */
  function alreadySeen(freq, key) {
    try {
      if (freq === 'session') return window.sessionStorage.getItem(key) === '1';
      if (freq === 'day' || freq === 'week') {
        var ts = parseInt(window.localStorage.getItem(key), 10);
        if (!ts) return false;
        return (Date.now() - ts) < (freq === 'day' ? DAY : 7 * DAY);
      }
    } catch (e) {}
    return false;
  }

  function markSeen(freq, key) {
    try {
      if (freq === 'session') window.sessionStorage.setItem(key, '1');
      else if (freq === 'day' || freq === 'week') window.localStorage.setItem(key, String(Date.now()));
    } catch (e) {}
  }

  /* ---------- scroll lock (restores exactly what it changed) ---------- */
  var saved = null;
  function lockScroll() {
    if (saved) return;
    var de = document.documentElement, b = document.body;
    saved = {
      deOverflow: de.style.overflow, deRight: de.style.paddingRight, bOverflow: b.style.overflow
    };
    var bar = window.innerWidth - de.clientWidth;
    de.style.overflow = 'hidden';
    b.style.overflow = 'hidden';
    if (bar > 0) de.style.paddingRight = bar + 'px';
  }
  function unlockScroll() {
    if (!saved) return;
    var de = document.documentElement, b = document.body;
    de.style.overflow = saved.deOverflow;
    de.style.paddingRight = saved.deRight;
    b.style.overflow = saved.bOverflow;
    saved = null;
  }

  function init(root) {
    if (!root || root.__yhp) return;
    var dialog = root.querySelector('[data-yhp-dialog]');
    var img = root.querySelector('.yhp__img');
    var closeBtn = root.querySelector('.yhp__close');
    if (!dialog || !img || !closeBtn) return;

    var freq = root.getAttribute('data-frequency') || 'session';
    var key = STORAGE_PREFIX + (root.getAttribute('data-version') || 'default');
    var delay = parseInt(root.getAttribute('data-delay'), 10) || 0;
    var editing = designMode();
    var force = forced();

    var timers = [];
    var isOpen = false;
    var opening = false;
    var destroyed = false;
    var lastFocus = null;

    function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }
    function clearTimers() { timers.forEach(clearTimeout); timers = []; }

    function onKey(e) {
      if (!isOpen) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        close();
      } else if (e.key === 'Tab') {
        // The close button is the only focusable control: keep focus inside the dialog.
        e.preventDefault();
        closeBtn.focus();
      }
    }

    function abort() {
      // Image failed or took too long: never leave an empty overlay behind.
      opening = false;
      root.classList.remove('is-open');
      root.hidden = true;
    }

    function reveal() {
      if (destroyed || !opening) return;
      opening = false;
      isOpen = true;
      openInstance = api;
      if (!editing && !force) markSeen(freq, key);
      lastFocus = document.activeElement;
      lockScroll();
      root.classList.add('is-open');
      document.addEventListener('keydown', onKey, true);
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }

    function open() {
      if (destroyed || isOpen || opening) return;
      if (openInstance && openInstance !== api) return; // never stack popups
      opening = true;
      root.hidden = false; // un-hide so the lazy image starts loading
      var done = function () { later(reveal, 0); };
      if (img.complete && img.naturalWidth > 0) { done(); return; }
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', abort, { once: true });
      later(function () { if (opening) abort(); }, 10000); // hard timeout
    }

    function close() {
      if (!isOpen && !opening) return;
      clearTimers();
      opening = false;
      isOpen = false;
      if (openInstance === api) openInstance = null;
      document.removeEventListener('keydown', onKey, true);
      root.classList.remove('is-open');
      unlockScroll();
      var finish = function () { if (!isOpen) root.hidden = true; };
      if (reduced()) finish(); else later(finish, 320);
      try {
        if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
      } catch (e) {}
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-yhp-close]')) { e.preventDefault(); close(); }
    });

    var api = { open: open, close: close, destroy: function () {
      destroyed = true; clearTimers(); close(); root.__yhp = null;
    } };
    root.__yhp = api;

    // Decide whether to show.
    if (editing) {
      later(open, 300);                         // editor: always preview, ignore storage
    } else if (force) {
      later(open, delay);                       // ?yh_popup=1: ignore frequency
    } else if (!alreadySeen(freq, key)) {
      later(open, delay);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-yhp]').forEach(init);
  }
  window.__yhpInitAll = function () { initAll(); };

  // Safety nets: scroll must never stay locked.
  window.addEventListener('pagehide', function () { unlockScroll(); });
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && !openInstance) unlockScroll();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-yhp]');
    if (root && root.__yhp) root.__yhp.open();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-yhp]').forEach(function (n) { if (n.__yhp) n.__yhp.destroy(); });
    unlockScroll();
  });
})();
